/** Default-off presentation opt-in. Global rows never enable a tenant. */
export const ROSTER_MASTER_GRID_FLAG = 'roster_master_grid_v1';
export function isTenantScopedMasterGridFlag(key: string | null | undefined): boolean {
  return key === ROSTER_MASTER_GRID_FLAG;
}
